module.exports = __webpack_public_path__ + "4299677bd39aee2124d9bec7228afeaa.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/tomhorn/assets/153.png
// module id = 1748
// module chunks = 2